// src/constants/permissions.js

const Permissions = {
  Bilty: {
    View: "CAN_VIEW_BILTY",
    Create: "CAN_CREATE_BILTY",
    Update: "CAN_UPDATE_BILTY",
    Delete: "CAN_DELETE_BILTY",
  },
  Company: {
    ViewCompany: "CAN_VIEW_COMPANY",
    CreateCompany: "CAN_CREATE_COMPANY",
    UpdateCompany: "CAN_UPDATE_COMPANY",
    CreateCompanyBranch: "CAN_CREATE_BRANCH",
    ViewCompanyBranch: "CAN_VIEW_BRANCH",
    UpdateCompanyBranch: "CAN_UPDATE_BRANCH",
  },
  Load: {
    View: "CAN_VIEW_LOAD",
    CreateAlerts: "CAN_CREATE_LOAD_ALERTS",
    CreateDocument: "CAN_CREATE_LOAD_DOCUMENT",
    LoadAction: "CAN_ACTION_LOAD",
    LoadDocumentAction: "CAN_ACTION_LOAD_DOCUMENT",
    AssignTransporter: "CAN_ASSIGN_TRANSPORTER",
  },
  Shipper: {
    View: "CAN_VIEW_SHIPPER",
    Update: "CAN_UPDATE_SHIPPER",
  },
  Transporter: {
    View: "CAN_VIEW_TRANSPORTER",
    Update: "CAN_UPDATE_TRANSPORTER",
  },
  Truck: {
    CreateTruckType: "CAN_CREATE_TRUCK_TYPES",
    UpdateTruckType: "CAN_UPDATE_TRUCK_TYPES",
    ViewTruckType: "CAN_VIEW_TRUCK_TYPES",
    ViewTrucks: "CAN_VIEW_TRUCKS",
  },
  KYC: {
    RequestView : "CAN_VIEW_KYC",
    RequestAction : "CAN_ACTION_KYC",
    DocumentView : "CAN_VIEW_KYC_DOCUMENTS",
    CreateDocument : "CAN_CREATE_KYC_DOCUMENTS",
    SectionView : "CAN_VIEW_KYC_SECTIONS",
    SectionManage : "CAN_MANAGE_KYC_SECTIONS",
  },
  Pincode: {
    View: "CAN_VIEW_PINCODES",
    Create: "CAN_CREATE_PINCODES",
    Update: "CAN_UPDATE_PINCODES",
  },
  Roles: {
    View: "CAN_VIEW_ROLES",
    Create: "CAN_CREATE_ROLES",
    Assign: "CAN_ASSIGN_PERMISSIONS",
  },
  FileExplorer :{
    View: "CAN_VIEW_FILES",
  },
  Users: {
    View: "CAN_VIEW_USERS",
    Create: "CAN_CREATE_USERS",
    Update: "CAN_UPDATE_USERS",
    Deactivate: "CAN_DEACTIVATE_USERS",
  },
};

export default Permissions;
